import config from "../config";
import { serviceInstance } from "../axiosInterceptor/requestHandler";

const businessService = {
  //GET
  fetchBusinessAll: (pageData) => {
    return serviceInstance
      .get(
        `${config.baseurl}/Account/Business/All?query=${pageData.query}&Page=${pageData.page}&PageLimit=${pageData.pageLimit}`
      )
      .then(({ data, status }) => {
        return data;
      });
  },
  fetchBusiness: (patgeData, status) =>
    serviceInstance
      .get(
        `${config.baseurl}/Account/Business/All?query=${patgeData.query}&Page=${patgeData.page}&PageLimit=10&status=${status}`
      )
      .then(({ data, status }) => {
        return data;
      }),
  fetchBusinessummary: (id) =>
    serviceInstance
      .get(`${config.baseurl}/Account/Business/Category`)
      .then(({ data, status }) => ({
        ...data,
      })),

  fetchBusinessDropdown: () =>
    serviceInstance
      .get(`${config.baseurl}/Account/Business/DropDownList`)
      .then(({ data, status }) => {
        return data;
      }),

  fetchBusinessInventory: (id) =>
    serviceInstance
      .get(`${config.baseurl}/Inventory/Company/Summary?CompanyId=${id}`)
      .then(({ data, status }) => {
        return data;
      }),

  fetchBusinessInfo: (id) =>
    serviceInstance
      .get(`${config.baseurl}/Account/Business/Details?Id=${id}`)
      .then(({ data, status }) => {
        return data;
      }),

  fetchBusinessWalletTransactions: (requestData) =>
    serviceInstance
      .get(
        `${config.baseurl}/Wallet/AllTransactions?CompanyId=${requestData.id}&startDate=${requestData.startDate}&endDate=${requestData.endDate}&Page=${requestData.pageData.page}&PageLimit=${requestData.pageData.pageLimit}&query=${requestData.pageData.query}&range=5`
      )
      .then(({ data, status }) => {
        return data;
      }),

  fetchBusinessOrdersLists: (requestData) =>
    serviceInstance
      .get(
        `${config.baseurl}/DepotProductOrder/Company?CompanyId=${requestData.id}&startDate=${requestData.startDate}&endDate=${requestData.endDate}&Page=${requestData.pageData.page}&PageLimit=${requestData.pageData.pageLimit}&query=${requestData.pageData.query}&excel=false&exportTo=Excel&range=5`
      )
      .then(({ data, status }) => {
        return data;
      }),

  getInventoryLog: (requestData) =>
    serviceInstance
      .get(
        `${config.baseurl}/DepotTruck/GetScheduleOrders?CompanyId=${requestData.id}&startDate=${requestData.startDate}&endDate=${requestData.endDate}&Page=${requestData.pageData.page}&PageLimit=${requestData.pageData.pageLimit}&query=${requestData.pageData.query}&excel=false&exportTo=Excel`
      )
      .then(({ data, status }) => {
        return data;
      }),
  // getSuspensionLog: async (requestData) => {
  //   return serviceInstance
  //     .get(
  //       `${config.baseurl}/Admin/SuspendUserAccountEventLog/${
  //         requestData.ownerId
  //       }?startDate=${requestData.startDate}&endDate=${
  //         requestData.endDate
  //       }&PageLimit=${requestData.urlProps.pageLimit}&Page=${
  //         requestData.urlProps.page
  //       }&Query=${requestData.urlProps.query ? requestData.urlProps.query : ""}`
  //     )
  //     .then(({ data }) => data);
  // },

  getSuspensionLog: (id, dateRange, pageData) =>
    serviceInstance
      .get(
        `${config.baseurl}/Admin/SuspendUserAccountEventLog/${id}?startDate=${
          dateRange.start
        }&endDate=${dateRange.end}&PageLimit=${pageData.pageLimit}&Page=${
          pageData.page
        }&Query=${pageData.query ? pageData.query : ""}`
      )
      .then(({ data, status }) => {
        return data;
      }),

  approveBusiness: (id) =>
    serviceInstance
      .post(`${config.baseurl}/Account/Business/Approve`, {id})
      .then(({ data, status }) => {
        return { data, status };
      }),

  declineBusiness: (id, data) =>
    serviceInstance
      .post(`${config.baseurl}/Account/Business/Decline/${id}`, data)
      .then(({ data, status }) => {
        return { data, status };
      }),

  //PUT
  updateBusiness: (data) =>
    serviceInstance
      .put(`${config.baseurl}/Account/Business/Edit`, data)
      .then(({ data, status }) => ({
        data,
      })),

  //POST
  createBusiness: (data) =>
    serviceInstance
      .post(`${config.baseurl}/Account/Business/Create`, data)
      .then(({ data, status }) => ({
        data,
      })),

  onboardBusiness: (data, id) =>
    serviceInstance
      .post(`${config.baseurl}/Onboard?userId=${id}`, data)
      .then(({ data, status }) => ({
        data,
      })),

  suspendBusiness: (data) =>
    serviceInstance
      .post(`${config.baseurl}/Admin/SuspendBusinessAccount`, data)
      .then(({ data, status }) => {
        return { data, status };
      }),

  activateBusiness: (id) =>
    serviceInstance
      .post(`${config.baseurl}/Admin/ActivateBusinessAccount/${id}`, {})
      .then(({ data, status }) => {
        return { data, status };
      }),
  increaseCreditLimit: (data) =>
    serviceInstance
      .post(`${config.baseurl}/Admin/UpdateBusinessCreditLimit`, data)
      .then(({ data, status }) => {
        return { data, status };
      }),
  businessDocument: (data) => {
    return serviceInstance
      .get(`${config.baseurl}/Account/Business/Documents/${data}`)
      .then(({ data, status }) => {
        return { data, status };
      });
  },
  fetchLineChart: (id, date) => {
    return serviceInstance
      .get(
        `${config.baseurl}/Inventory/Product/LineChart?companyId=${id}&startDate=${date.start}&endDate=${date.end}&range=5`
      )
      .then((data, status) => {
        return { data, status };
      });
  },

  fetchDonutChart: (id, date) => {
    return serviceInstance
      .get(
        `${config.baseurl}/Inventory/Product/DonutChart?companyId=${id}&startDate=${date.start}&endDate=${date.end}&range=5`
      )
      .then((data, status) => {
        return { data, status };
      });
  },
};

export default businessService;
